<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's',
        [$style.selected]: selected
      }
    ]"
    v-test="'modal-details-nav'"
  >
    <div :class="$style.navItemInner">
      <slot />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  selected: boolean;
}>();

defineEmits(['nav']);
</script>

<style
  module
  lang="scss"
>
.base {
  cursor: pointer;
  display: flex;

  &.selected {
    cursor: auto;
  }

  &:not(.smallScreen) {
    align-items: center;
    padding: 20px 18px;
    border-left: 6px solid var(--color-bg);
    border-bottom: 2px solid var(--color-bg-secondary);

    &:hover {
      background-color: var(--color-highlight);
      border-left-color: var(--color-highlight);
    }

    &.selected {
      background-color: var(--color-bg-secondary);
      border-left: 6px solid var(--color-border-primary);
      border-bottom: none;
      padding: 20px 18px 22px;
    }
  }
  &.smallScreen {
    flex-grow: 1;
    padding: 0 $spacing * 0.5;
    background-color: var(--color-bg);
  }
}

.navItemInner {
  width: 100%;
  .smallScreen & {
    padding: $spacing;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 2px solid var(--color-bg-secondary);
  }

  .smallScreen.selected & {
    border-bottom: 2px solid var(--color-primary);
  }
}
</style>
